import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetDynamicPageDataResponse } from '@/modules/client-setting/type'
import DynamicPageTable from '../DynamicPageTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateDynamicPageModal from '../CreateDynamicPageModal'
import DynamicPageSelector from '../DynamicPageSelector'

interface DynamicPageListingProps {
	data: GetDynamicPageDataResponse[]
	total: number
	isLoading?: boolean
}

export default function DynamicPageListing({
	data,
	total,
	isLoading,
}: DynamicPageListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<div className="space-y-2">
					<Heading
						title={`การตั้งค่าหน้าเว็บ`}
						description="การตั้งค่าหน้าเว็บ"
					/>
					{hasWritePermission && <DynamicPageSelector data={data} />}
				</div>
				{hasWritePermission && <CreateDynamicPageModal />}
			</div>
			<Separator />
			<DynamicPageTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
